module.exports = __webpack_public_path__ + "img/plantao_folha_esocial.48c8e1bb.webp";